import * as React from "react";
import {
  Box,
  ImageList,
  ImageListItem,
  Typography,
  useMediaQuery,
} from "@mui/material";
import Container from "@mui/material/Container";

const galleryImages = [
  "THE ABBEY-01.jpg",
  "THE ABBEY-02.jpg",
  "THE ABBEY-03.jpg",
  "THE ABBEY-04.jpg",
  "THE ABBEY-05.jpg",
  "THE ABBEY-06.jpg",
];

const ImageListItemStyled = ({ image }) => {
  const imageFile = require(`../../images/assets/${image}`);

  return (
    <ImageListItem>
      <img
        src={`${imageFile}?w=248&fit=crop&auto=format`}
        srcSet={`${imageFile}?w=248&fit=crop&auto=format&dpr=2 2x`}
        alt="Gallery item"
        loading="lazy"
      />
    </ImageListItem>
  );
};

function PsychPub() {
  const matches = useMediaQuery("(min-width:600px)");

  return (
    <Container className="info" maxWidth="xl">
      <div className="info-content">
        <div className="text-section">
          <Typography className="title" variant="h6">
            MANCHESTER PSYCH FEST’S NEW STAGE & PUB
          </Typography>
        </div>

        <Box sx={{ flexGrow: 1, display: { xs: "flex" } }}>
          <ImageList variant="masonry" cols={matches ? 3 : 1} gap={8}>
            {galleryImages.map((image, index) => (
              <ImageListItemStyled key={index} image={image} />
            ))}
          </ImageList>
        </Box>
        <div className="text-section">
          <Typography className="title" variant="h6">
            Contact
          </Typography>
          <Typography className="text">info@manchesterpsychfest.com</Typography>
        </div>
      </div>
    </Container>
  );
}
export default PsychPub;
